export default {
             code:
`
   当您收到这封邀请函时，
   我们已经在倒数着日子举行婚礼。
   诚邀您携家人来参加我们的婚礼，
   人的一生大约有着三万多天，
   很开心这一天，您专为我们而来！   
`,
    executions: [{
        name: '结婚证书已领',
        time: '',
        duration: 0,
        visible: false
    }, {
        name: '良辰吉日已定',
        time: '',
        duration: 0,
        visible: false
    }, {
        name: '婚礼场地就绪',
        time: '',
        duration: 0,
        visible: false
    }, {
        name: '亲朋好友将至',
        time: '',
        duration: 0,
        visible: false
    }, {
        name: '打包幸福ing...',
        time: '',
        duration: 0,
        visible: false
    }, {
        name: '上传美好ing...',
        time: '',
        duration: 0,
        visible: false
    }, {
        name: '部署未来ing...',
        time: '',
        visible: false
    }],
    barrages: [
        '有情人终成眷属',
        '喜结良缘，幸福永久',
        '太赞了',
        '恭喜恭喜🎉🎉🎉🎉',
        '哇哇哇',
        '永结同心',
        '✿✿ヽ(°▽°)ノ✿',
        '😗 😙 😚 😋 ',
        '看你幸福，我也开心，最好的朋友',
        '百年好合',
        '恭喜恭喜🎉🎉🎉🎉',
        '哇哇哇',
        '永结同心',
        '祝福你们甜蜜美满哟',
        '😗百年好合，永久同心 ',
        '早生贵子',
        '祝福你们爱情长长久久',
        '白头偕老',
        '永结同心',
        '✿✿ヽ(°▽°)ノ✿',
        '😗 😙 😚 😋 ',
        '幸福长长久呀',
        '恭喜恭喜🎉🎉🎉🎉',
        '佳偶永相伴，幸福到永远',
        '永结同心',
        '✿✿ヽ(°▽°)ノ✿',
        '😗 😙 😚 😋 ',
        '幸福999'
    ],
}
